





















































































import {
  createComponent,
  inject,
  computed,
  ref,
  onMounted,
  reactive,
  watch,
  SetupContext
} from "@vue/composition-api";
import SnackBar from "../../../Common/SnackBar.vue";
import RealTimeTransferKey from "@/components/real-time-transfer-key";
import { isNullOrEmpty } from "@/methods/validation";
import WalletKey from "@/components/wallet-key";
import router from "@/router";
import SnackbarKey from "@/components/snackbar-key";

interface SnackBar {
  [prop: string]: any;
}

export default createComponent({
  components: { SnackBar },
  setup(props: {}, context: SetupContext) {
    const realTimeTransferStore = inject(RealTimeTransferKey);
    if (!realTimeTransferStore) {
      throw new Error(`${RealTimeTransferKey} is not provided`);
    }
    const walletStore = inject(WalletKey);
    if (!walletStore) {
      throw new Error(`${WalletKey} is not provided`);
    }
    const loadedFlag = ref<boolean>(false);
    const selectAccountInfos = computed(
      () => realTimeTransferStore.selectAccountInfos
    );
    const amount = ref<any>(null);
    const transfererInfos = computed(
      () => realTimeTransferStore.transfererInfos
    );
    const companyCommissionInfos = computed(
      () => realTimeTransferStore.companyCommissionInfos[0]
    );
    const rakuten_bank_code = "0036";

    // 残高取得
    const getBalance = () => {
      let list = walletStore.walletList;
      let company_wallet_data = list.filter(
        (e: any) =>
          e.company_code_item.internal_value ==
          transfererInfos.value.company_code
      );
      if (company_wallet_data) {
        return company_wallet_data[0]["account_balance"];
      } else {
        return 0;
      }
    };

    // 上限金額
    const upperLimit = reactive<any>({
      // 上限金画面表示用
      display: "",
      // 上限金
      value: 0,
      // 手数料
      commission: 0,
      commission_1: 0,
      commission_2: 0,
      commission_3: 0,
      commission_4: 0,
      commission_5: 0,
    });

    // 下限金額
    const lowerLimit = reactive<any>({
      // 下限金画面表示用
      display: "1,000",
      // 下限金
      value: 1000
    });

    watch(companyCommissionInfos, () => {
      let balance = getBalance();
      if (typeof companyCommissionInfos.value === "undefined") {
        return;
      }
      upperLimit.display =
        companyCommissionInfos.value.upper_limit_amount > balance
          ? balance
          : companyCommissionInfos.value.upper_limit_amount;
      upperLimit.display = Number(upperLimit.display).toLocaleString();
      upperLimit.value = companyCommissionInfos.value.upper_limit_amount;
      if (selectAccountInfos.value.bank_code == rakuten_bank_code) {
        upperLimit.commission_1 = companyCommissionInfos.value.rakuten_commission_1;
        upperLimit.commission_2 = companyCommissionInfos.value.rakuten_commission_2;
        upperLimit.commission_3 = companyCommissionInfos.value.rakuten_commission_3;
        upperLimit.commission_4 = companyCommissionInfos.value.rakuten_commission_4;
        upperLimit.commission_5 = companyCommissionInfos.value.rakuten_commission_5;
      } else {
        upperLimit.commission_1 = companyCommissionInfos.value.commission_1;
        upperLimit.commission_2 = companyCommissionInfos.value.commission_2;
        upperLimit.commission_3 = companyCommissionInfos.value.commission_3;
        upperLimit.commission_4 = companyCommissionInfos.value.commission_4;
        upperLimit.commission_5 = companyCommissionInfos.value.commission_5;
      }
    });

    // 登録ボタン押下後のスナックバー制御
    const snackbar = reactive<SnackBar>({
      display: false,
      error: false,
      message: ""
    });

    // 2.5秒間のスナックバー表示させる
    const displaySnackbar = (message: string) => {
      snackbar.message = message;
      snackbar.error = true;
      snackbar.display = true;
      // 2.5秒後にスナックバーを初期化する
      setTimeout(() => {
        snackbar.display = false;
        snackbar.error = false;
        snackbar.message = "";
      }, 2500);
    };
    // storeを注入
    const snackbarStore = inject(SnackbarKey);
    if (!snackbarStore) {
      throw new Error(`${snackbarStore} is not provided`);
    }

    const setAmount = (e: any) => {
      realTimeTransferStore.setAmount(e);
    };

    onMounted(async () => {
      loadedFlag.value = true;
      await realTimeTransferStore.getTransferCommission(
        transfererInfos.value.company_code
      );
      loadedFlag.value = false;
    });

    // 残高が足りるかどうか確認
    const checkBalance = () => {
      let balance = getBalance();
      if (balance < Number(upperLimit.commission) + Number(amount.value)) {
        return true;
      } else {
        return false;
      }
    };

    // 振込下限額を下回っていないか確認
    const checkLowerLimit = () => {
      if (lowerLimit.value > Number(amount.value)) {
        return true;
      } else {
        return false;
      }
    };

    // 振込金額から手数料の判定
    const checkCommission = (e: any) => {
      if (e >= 1 && e <= 30000) {
        upperLimit.commission = upperLimit.commission_1;
        realTimeTransferStore.setCommission(upperLimit.commission_1);
      } else if(e >= 30001 && e <= 60000) {
        upperLimit.commission = upperLimit.commission_2;
        realTimeTransferStore.setCommission(upperLimit.commission_2);
      } else if(e >= 60001 && e <= 90000) {
        upperLimit.commission = upperLimit.commission_3;
        realTimeTransferStore.setCommission(upperLimit.commission_3);
      } else if(e >= 90001 && e <= 120000) {
        upperLimit.commission = upperLimit.commission_4;
        realTimeTransferStore.setCommission(upperLimit.commission_4);
      } else if(e >= 120001 && e <= 150000) {
        upperLimit.commission = upperLimit.commission_5;
        realTimeTransferStore.setCommission(upperLimit.commission_5);
      } else {
        upperLimit.commission = upperLimit.commission_1;
        realTimeTransferStore.setCommission(upperLimit.commission_1);
      }
    };

    // 確認ボタン押下後の処理
    const confirm = () => {
      // 振込金額から手数料を計算する
      checkCommission(amount.value);
      // 入力項目に不備があるかチェック
      if (
        isNullOrEmpty(amount) ||
        amount.value <= 0 ||
        amount.value > upperLimit.value
      ) {
        return;
        // 手数料を足し合わせた金額が残高を超えていないかチェック
      } else if (checkBalance()) {
        displaySnackbar(
          "手数料" +
            upperLimit.commission +
            "円分を含んだ合計金額に残高が足りません"
        );
        return;
        // 振込下限額を下回っていないかチェック
      } else if (checkLowerLimit()) {
        displaySnackbar("振込下限額を下回っています");
        return;
      } else {
        loadedFlag.value = true;
        setAmount(amount.value);
        context.root.$router.push({name: "RealTimeTransferRequestConfirm"});
        loadedFlag.value = false;
      }
    };

    return {
      loadedFlag,
      selectAccountInfos,
      amount,
      transfererInfos,
      companyCommissionInfos,
      upperLimit,
      lowerLimit,
      snackbar,
      getBalance,
      setAmount,
      confirm,
      isNullOrEmpty
    };
  }
});
